import { affiliateApi } from '../lib/axios';

export interface SneakylinkResponse {
  token: string;
  url: string;
  // Shop-origin landing URL carrying a signed `rs_token` (sneakylink_redeem)
  // returned by the backend; preferred over `url` when present.
  storeUrl?: string;
  expiresAt?: string;
  clickCount: number;
  conversionCount: number;
}

export interface SneakylinkClickResponse {
  code: string;
  codes?: string[];
  brandName: string;
  brandLogo: string;
  discountValue: string;
  discountType: string;
  redirectUrl: string;
  expiresAt: string;
}

export interface SneakylinkAnalytics {
  clicks: number;
  conversions: number;
  conversionRate: number;
  totalRevenue: number;
  averageOrderValue: number;
}

class SneakylinkService {
  async generateSneakylink(programId: string): Promise<SneakylinkResponse> {
    const response = await affiliateApi.post('/sneakylink/generate', { programId });
    return response.data;
  }
  
  async processSneakylink(token: string, count?: number): Promise<SneakylinkClickResponse> {
    const response = await affiliateApi.get(`/sneakylink/${token}`, {
      params: count ? { count } : undefined,
    });
    return response.data;
  }
  
  async getMySneakylinks(programId?: string): Promise<SneakylinkResponse[]> {
    const response = await affiliateApi.get('/sneakylink/my-links', { 
      params: { programId } 
    });
    return response.data;
  }
  
  async getSneakylinkAnalytics(sneakylinkId: string): Promise<SneakylinkAnalytics> {
    const response = await affiliateApi.get(`/sneakylink/${sneakylinkId}/analytics`);
    return response.data;
  }
}

export const sneakylinkService = new SneakylinkService();

